export const numberCheck=(e)=> {
    const re = /^\d+$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }